import type { IconNode } from '../types';

/**
 * @name burger
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNSAxMmEyIDIgMCAwIDEtMi0yIDkgNyAwIDAgMSAxOCAwIDIgMiAwIDAgMS0yIDJsLTMuNSA0LjFjLS44IDEtMi40IDEuMS0zLjQuM0w3IDEyIiAvPgogIDxwYXRoIGQ9Ik0xMS43IDE2SDRhMiAyIDAgMCAxIDAtNGgxNmEyIDIgMCAwIDEgMCA0aC00LjMiIC8+CiAgPHBhdGggZD0iTTUgMTZhMiAyIDAgMCAwLTIgMmMwIDEuNyAxLjMgMyAzIDNoMTJjMS43IDAgMy0xLjMgMy0zYTIgMiAwIDAgMC0yLTIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/burger
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const burger: IconNode = [
  [
    'path',
    {
      d: 'M5 12a2 2 0 0 1-2-2 9 7 0 0 1 18 0 2 2 0 0 1-2 2l-3.5 4.1c-.8 1-2.4 1.1-3.4.3L7 12',
      key: 'tuwmkq',
    },
  ],
  ['path', { d: 'M11.7 16H4a2 2 0 0 1 0-4h16a2 2 0 0 1 0 4h-4.3', key: '66c14r' }],
  [
    'path',
    { d: 'M5 16a2 2 0 0 0-2 2c0 1.7 1.3 3 3 3h12c1.7 0 3-1.3 3-3a2 2 0 0 0-2-2', key: 'gmww6b' },
  ],
];

export default burger;
